import React from 'react';
import { useSelector } from 'react-redux';

import type { FlysiteUrls } from 'hooks/useFlysiteUrls';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls';
import { getCurrentLocale } from 'selectors';
import { getDisplayName } from 'utils/getDisplayName/getDisplayName';

const WithFlysiteUrls = <P extends Record<string, unknown>>(
  WrappedComponent: React.ComponentType<P & FlysiteUrls>,
) => {
  const WithFlysiteUrls = (props: P) => {
    const locale = useSelector(getCurrentLocale);
    const urls = useFlysiteUrls(locale);
    return <WrappedComponent {...props} {...urls} />;
  };

  WithFlysiteUrls.displayName = `WithFlysiteUrls(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithFlysiteUrls;
};

export { WithFlysiteUrls };
